import { render, staticRenderFns } from "./v-markdown.vue?vue&type=template&id=4da20fd4&lang=pug&"
import script from "./v-markdown.ts?vue&type=script&lang=ts&"
export * from "./v-markdown.ts?vue&type=script&lang=ts&"
import style0 from "./v-markdown.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports